import { NgModule } from '@angular/core';
import { ToastComponent } from './layouts';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DxLoadPanelModule } from 'devextreme-angular';
import { ProviderList } from './app-provider-registrar';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#A79EF3',
  bgsOpacity: 0.5,
  bgsPosition: 'center-center',
  bgsSize: 70,
  bgsType: 'three-strings',
  fgsColor: '#A79EF3',
  fgsPosition: 'center-center',
  fgsSize: 70,
  fgsType: 'three-strings',
  hasProgressBar: false,
};

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    NgbToastModule,
    DxLoadPanelModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ...ProviderList
  ],
  bootstrap: [AppComponent]
})

export class AppModule {

}
